export function getCNPJMask(cnpj: string): string {
  return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`;
}

export function getCpfFormated(inCpf: string): string {
  if (inCpf != null && inCpf.length === 11) {
    return inCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return inCpf;
}

export default getCNPJMask;
